import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onChange"];
import React, { memo, useState, useCallback } from 'react';
import { createUseStyles, Switch } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'SwitchCell');
const SwitchCell = /*#__PURE__*/memo(params => {
  const [isChecked, setIsChecked] = useState(params.value || false);
  const classes = useStyles();
  const field = params.colDef.field;
  const _params$inputParams = params.inputParams,
    {
      onChange
    } = _params$inputParams,
    inputParams = _objectWithoutProperties(_params$inputParams, _excluded);
  const handleOnChange = useCallback(() => {
    const id = params.data.id || params.data.Id || params.data.ID || '';
    onChange({
      rowIndex: params.node.rowIndex,
      id,
      field,
      value: !isChecked
    });
    setIsChecked(!isChecked);
  }, [isChecked, onChange, field, params]);
  if (!params.inputParams) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: ['w5-cell', classes.editableCell].join(' ')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.switchCell
  }, /*#__PURE__*/React.createElement(Switch, _extends({
    checked: isChecked,
    onChange: handleOnChange
  }, inputParams))));
});
export default SwitchCell;